export default __webpack_public_path__ + "static/media/Illustration-No-Conversations-Yet.e1650053.svg";